import React from "react";
import { Form } from "antd";
// import BrandAssetsForm from "./BrandAssetsForm"; // import your existing form
import styles from "../styles/BusinessInfo.module.css";
import BrandAssetsForm from "../../qbuilt_settings/brands/org/BrandAssetsForm";
import log from "cslog";

export default function BrandAssists({ answers, onAnswerChange }) {
    const [form] = Form.useForm();

    log.d(answers, "Answers in BASS");

    // initialize with answers
    React.useEffect(() => {
        form.setFieldsValue({
            logo: answers.mainLogo,
            logo_square: answers.squareLogo,
            logo_dark: answers.darkLogo,
            // primary_phone: answers.phone,
            // primary_email: answers.email,
            // address: answers.address,
            // website: answers.website,
            brand_colors: answers.brandColors,
            color_palettes: answers.colorPalettes,
            // linkedin_handle: answers.socialHandles?.linkedin,
            // instagram_handle: answers.socialHandles?.instagram,
            // facebook_handle: answers.socialHandles?.facebook,
            // youtube_handle: answers.socialHandles?.youtube,
            // pinterest_handle: answers.socialHandles?.pinterest,
        });
    }, [answers, form]);

    // sync changes back to parent
    const handleValuesChange = (_, allValues) => {
        onAnswerChange("mainLogo", allValues.logo);
        onAnswerChange("squareLogo", allValues.logo_square);
        onAnswerChange("darkLogo", allValues.logo_dark);
        // onAnswerChange("phone", allValues.primary_phone);
        // onAnswerChange("email", allValues.primary_email);
        // onAnswerChange("address", allValues.address);
        // onAnswerChange("website", allValues.website);
        onAnswerChange("brandColors", allValues.brand_colors);
        onAnswerChange("colorPalettes", allValues.color_palettes);
        // onAnswerChange("socialHandles", {
        //     linkedin: allValues.linkedin_handle,
        //     instagram: allValues.instagram_handle,
        //     facebook: allValues.facebook_handle,
        //     youtube: allValues.youtube_handle,
        //     pinterest: allValues.pinterest_handle,
        // });
    };

    return (
        <div className={styles.brandAssistContent}>
            <h2 className={styles.slideTitle}>Brand Assets</h2>
            <p className={styles.slideSubtitle}>
                You can edit this data later as well.
            </p>

            <Form
                form={form}
                layout="vertical"
                initialValues={answers}
                onValuesChange={handleValuesChange}
            >
                <BrandAssetsForm form={form} />
            </Form>
        </div>
    );
}
